import React, { Component } from 'react'
import { Table, DatePicker, Button, message, Modal } from 'antd'
import moment from 'moment'
import { round } from '../../../../util/index'
import { voidServiceList, restoreService } from '../../../../api/employee'
const { RangePicker } = DatePicker

const nowDate = new Date()
nowDate.setMonth(nowDate.getMonth() - 1)
nowDate.setDate(1)
nowDate.setHours(0, 0, 0, 0)
const nextDate = new Date()
nextDate.setMonth(nowDate.getMonth() + 1, 0)
nextDate.setHours(0, 0, 0, 0)

export default class voidTable extends Component {
  state = {
    isloading: false,
    pickerValue: [
      moment(nowDate, 'YYYY-MM-DD'),
      moment(nextDate, 'YYYY-MM-DD'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.startOf('day')
    eTime.add(1, 'day')
    eTime.startOf('date')
    const { status, detail, data } = await voidServiceList({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({ isloading: false })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const newData = dataAry.map((item) => {
        const { member, employee, service } = item
        const hour = Math.floor(service.duration / 3600)
        const minute = Math.floor((service.duration % 3600) / 60)
        return {
          serviceId: service.serviceId,
          name: employee ? employee.name : '',
          account: member ? member.account : '',
          createTime: moment(service.startTime).format('YYYY-MM-DD'),
          identityType: service.identityType > 1 ? '记分员' : '助教',
          serviceDuration: `${moment(service.startTime).format('HH:mm')}-${moment(service.endTime).format('HH:mm')}`,
          duration: `${hour}小时${minute}分钟`,
          serviceAmount: round(service.amount / 100, 2),
          commission: round(service.commission / 100, 2),
          voidTime: service.voidTime ? moment(service.voidTime).format('YYYY-MM-DD HH:mm') : '',
          voidOperator: service.voidOperator || '',
          voidReason: service.voidReason || '',
        }
      })
      this.setState({ list: newData })
    } else {
      this.setState({ list: [] })
    }
  }

  onChange = (value) => {
    if (!value) return
    this.setState({ pickerValue: value })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({ dates: [], hackValue: [] })
    } else {
      this.setState({ hackValue: undefined })
    }
  }

  onCalendarChange = (val) => {
    this.setState({ dates: val })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    const tooLate = this.state.dates[0] && current.diff(this.state.dates[0], 'days') > 30
    const tooEarly = this.state.dates[0] && this.state.dates[0].diff(current, 'days') > 30
    return tooLate || tooEarly || current >= moment()
  }

  onSearchEvent = () => {
    if (this.state.isloading) return
    this.setState({ isloading: true }, this.getDatas)
  }

  showRestoreModal = (record) => {
    Modal.confirm({
      title: '恢复确认',
      content: '恢复后，该条记录将重新计入助教提成，是否确认恢复？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const { status, detail } = await restoreService({
          serviceId: record.serviceId,
        })
        if (status != 1) {
          message.error(detail || '恢复失败')
          return
        }
        message.success('恢复成功')
        this.getDatas()
      },
    })
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const columns = [
      { title: '日期', dataIndex: 'createTime' },
      { title: '用户', dataIndex: 'account' },
      { title: '服务员', dataIndex: 'name' },
      { title: '服务', dataIndex: 'identityType' },
      { title: '时间', dataIndex: 'serviceDuration' },
      { title: '时长', dataIndex: 'duration' },
      { title: '服务费(元)', dataIndex: 'serviceAmount' },
      { title: '分成(元)', dataIndex: 'commission' },
      { title: '作废时间', dataIndex: 'voidTime' },
      { title: '操作人', dataIndex: 'voidOperator' },
      { title: '作废原因', dataIndex: 'voidReason' },
      {
        title: '操作',
        render: (_, record) => (
            <div style={{ color: "blue", cursor: "pointer" }} onClick={() => this.showRestoreModal(record)}>恢复</div>
        ),
      },
    ]
    return (
      <div>
        <div className="csr-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="csr-button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
        </div>
        <Table
          rowKey="serviceId"
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubServiceRecord/component/voidTable/voidTable.js